<template>
  <header class="top-bar main-padding">
    <div class="d-flex align-items-center gap-1 flex-grow-1 flex-wrap">
      <div class="" v-if="isSuperadminLoggedSchool && !isTeacher">
        <button @click="backToSuperadminPanel" class="btn btn-primary btn-sm">
          <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
          {{ Lang.get("messages.back_to_superadmin_panel") }}
        </button>
      </div>

      <!-- School Switcher Moved Here -->
      <div
        class="dropdown school-switcher-navbar mx-2"
        v-if="!isTeacher && isSystemAdmin"
      >
        <button
          class="btn modern-lang-btn-navbar d-flex align-items-center gap-2 dropdown-toggle reset-view-btn"
          type="button"
          @click="toggleSchoolSelector"
          :title="Lang.get('messages.select_school')"
        >
          <div class="lang-icon-wrapper">
            <i class="fas fa-university"></i>
          </div>
          <span class="lang-text d-none d-md-inline">{{
            user.school ? user.school.name : Lang.get("messages.select_school")
          }}</span>
        </button>

        <div
          v-if="showSchoolSelector"
          class="dropdown-menu show modern-lang-dropdown"
          style="
            left: auto;
            right: auto;
            max-height: 400px;
            overflow-y: auto;
            width: 250px;
          "
        >
          <div class="dropdown-header px-3 py-2">
            <small class="text-muted">{{
              Lang.get("messages.available_schools") || "المدارس المتاحة"
            }}</small>
          </div>
          <a
            class="dropdown-item text-primary font-weight-bold border-bottom mb-2"
            href="#"
            @click.prevent="backToSuperadminPanel"
          >
            <i class="fas fa-home mr-2"></i>
            {{ Lang.get("messages.back_to_superadmin_panel") }}
          </a>
          <a
            class="dropdown-item d-flex align-items-center justify-content-between"
            href="#"
            v-for="school in schools"
            :key="school.id"
            @click.prevent="selectSchool(school)"
            :class="{ active: user.school && user.school.id === school.id }"
          >
            <span>{{ school.name }}</span>
            <i
              v-if="user.school && user.school.id === school.id"
              class="fas fa-check"
            ></i>
          </a>
          <div v-if="schools.length === 0" class="text-center p-3 text-muted">
            <i class="fas fa-spinner fa-spin mr-2"></i>
            {{ Lang.get("messages.loading") || "جاري التحميل..." }}
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mx-content">
      <div class="d-flex align-items-center gap-2">
        <!-- Teacher Notifications -->
        <div class="back_home" v-if="isHodLoggedAsTeacher">
          <button
            @click="backToHodDashboard"
            class="btn btn-border-secondary fs-12 back_btn"
          >
            {{ Lang.get("messages.back_to_main") }}
          </button>
        </div>
        <div class="dropdown user-controls" v-if="isTeacher">
          <button
            class="notifications-button header_icon dropdown-toggle"
            type="button"
            id="dropdownMenuButton2"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              src="/assets/front_end/portals/images/icons/chat.svg"
              class="icon-lg"
              alt="Chat"
            />
            <span class="indicator" aria-hidden="true">{{
              notifications.length
              }}</span>
          </button>
          <div
            class="dropdown-menu chat"
            aria-labelledby="dropdownMenuButton2"
            v-if="isTeacher"
          >
            <h5 class="dropdown_header custom-h">
              <span class="relative-indicator" aria-hidden="true">
                {{ notifications.length }}</span
              >
              <span>{{ Lang.get("messages.chats") }}</span>
            </h5>
            <ul class="custom-ul" v-if="notifications.length > 0">
              <li
                class="d-flex gap-2 align-items-start"
                v-for="(notification, index) in notifications"
                :key="index"
              >
                <router-link
                  :to="{
                    name: 'teacher-messenger',
                    params: {
                      class_id: _.get(
                        getParentClass(notification.sender?.classes),
                        'id',
                      ),
                      user_id: notification.sender?.id,
                    },
                  }"
                  class="dropdown-item"
                >
                  <img
                    src="/assets/front_end/portals/images/user.svg"
                    class="chat_img"
                    alt="User"
                  />
                  <div class="w-100">
                    <h6 class="custom-h">
                      {{
                        _.get(
                          getParentClass(notification.sender?.classes),
                          "name",
                        )
                      }}
                    </h6>
                    <h6
                      class="fs-12 gray-color custom-h mt-2 d-flex gap-1 justify-content-between"
                    >
                      <span>{{ notification.message }}</span>
                    </h6>
                  </div>
                </router-link>
              </li>
              <li class="d-flex gap-2 align-items-start" v-if="isTeacher">
                <router-link
                  :to="{ name: 'teacher-messenger' }"
                  class="dropdown-item"
                >
                  {{ Lang.get("messages.open_messenger") }}
                </router-link>
              </li>
            </ul>
            <div v-else class="text-center p-4 text-muted">
              <div class="mb-2">
                <i class="far fa-bell-slash fa-2x text-gray-400"></i>
              </div>
              <p class="m-0 fs-12">
                {{ Lang.get("messages.no_notifications") }}
              </p>
              <div class="mt-2" v-if="isTeacher">
                <router-link
                  :to="{ name: 'teacher-messenger' }"
                  class="btn btn-sm btn-light"
                >
                  {{ Lang.get("messages.open_messenger") }}
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- MongoDB Notifications -->
        <div class="dropdown" v-if="!isSuperadmin">
          <button
            class="notifications-button header_icon dropdown-toggle"
            type="button"
            id="dropdownMenuButton4"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              src="/assets/front_end/portals/images/icons/Bell.svg"
              class="icon-lg"
            />
            <span class="indicator" aria-hidden="true">{{
              mongoNotificationsCount
              }}</span>
          </button>
          <div
            class="dropdown-menu notification"
            aria-labelledby="dropdownMenuButton4"
          >
            <h5 class="dropdown_header custom-h">
              <span class="relative-indicator" aria-hidden="true">
                {{ mongoNotificationsCount }}</span
              >
              <span>{{ Lang.get("messages.notifications_title") }}</span>
            </h5>
            <ul class="custom-ul" v-if="mongoNotifications.length > 0">
              <li
                class="d-flex gap-2 align-items-start"
                v-for="(notification, index) in mongoNotifications"
                :key="index"
                @click="
                  markNotificationAsRead(notification.id, notification.link)
                "
              >
                <img
                  src="/assets/front_end/portals/images/blue_logo.svg"
                  class="notification_img"
                />
                <div>
                  <h6
                    class="custom-h"
                    :class="{ 'fw-bold': !notification.is_read }"
                  >
                    {{ notification.title }}
                  </h6>
                  <h6 class="fs-12 gray-color custom-h mt-2">
                    {{ notification.body }}
                  </h6>
                  <h6 class="fs-12 gray-color custom-h mt-3 d-flex gap-1">
                    <i class="far fa-clock"></i>
                    <span>{{ notification.date }}</span>
                  </h6>
                </div>
              </li>
            </ul>
            <div v-else class="text-center p-4 text-muted">
              <div class="mb-2">
                <i class="far fa-bell-slash fa-2x text-gray-400"></i>
              </div>
              <p class="m-0 fs-12">
                {{ Lang.get("messages.no_notifications") }}
              </p>
            </div>
            <hr class="my-2" />
            <router-link
              :to="{ name: 'show-notifications' }"
              class="custom-anc secondary text-center d-block"
            >
              {{ Lang.get("website.show_all") }}
            </router-link>
          </div>
        </div>

        <!-- Favorites -->
        <div class="dropdown" v-if="!isTeacher && !isHod">
          <button
            class="explore-button header_icon dropdown-toggle"
            v-if="!isTeacher || !isHodLoggedAsTeacher"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              src="/assets/front_end/assets/images/heart.svg"
              class="icon-lg"
              alt="Favorites"
            />
            <span class="indicator" aria-hidden="true">{{
              fav_list.length
              }}</span>
          </button>
          <ul
            class="dropdown-menu custom-ul"
            aria-labelledby="dropdownMenuButton"
            v-if="!isHodLoggedAsTeacher"
          >
            <li
              class="dropdown-item"
              v-for="(item, index) in fav_list"
              @click.stop
            >
              <router-link :to="{ path: item.path, query: item.query }">
                <h6 class="third-color custom-h">
                  {{ Lang.get(`messages.sidebar.${item.label}`) }}
                </h6>
              </router-link>
              <img
                src="/assets/front_end/assets/images/close-circle.svg"
                @click="removeFromFav(item)"
                style="cursor: pointer"
                alt="Remove"
              />
            </li>
          </ul>
        </div>
      </div>

      <!-- Modern Language Switcher -->
      <div class="dropdown lang-switcher-navbar">
        <button
          class="btn modern-lang-btn-navbar d-flex align-items-center gap-2 dropdown-toggle"
          type="button"
          id="langDropdownButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div class="lang-icon-wrapper">
            <i class="fas fa-globe"></i>
          </div>
          <span class="lang-text d-none d-md-inline">{{
            currentLanguageNativeName
          }}</span>
        </button>
        <div
          class="dropdown-menu dropdown-menu-right modern-lang-dropdown"
          aria-labelledby="langDropdownButton"
        >
          <div class="dropdown-header px-3 py-2">
            <small class="text-muted">{{
              Lang.get("messages.selectLanguage") || "اختر اللغة"
            }}</small>
          </div>
          <a
            v-for="lang in activeLanguages"
            :key="lang.code"
            class="dropdown-item d-flex align-items-center justify-content-between"
            :class="{ active: currentLocale === lang.code }"
            href="#"
            @click.prevent="handleLanguageChange(lang.code)"
          >
            <span>{{ lang.native_name }}</span>
            <i
              v-if="currentLocale === lang.code"
              class="fas fa-check text-success"
            ></i>
          </a>
        </div>
      </div>

      <!-- User Profile -->
      <div class="dropdown user-profile-navbar">
        <button
          class="btn modern-lang-btn-navbar d-flex align-items-center gap-2 dropdown-toggle"
          type="button"
          id="dropdownMenuButton3"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div class="lang-icon-wrapper">
            <i class="fas fa-user"></i>
          </div>
          <span class="lang-text d-none d-md-inline">{{ user.name }}</span>
        </button>
        <div
          class="dropdown-menu dropdown-menu-right modern-lang-dropdown"
          aria-labelledby="dropdownMenuButton3"
        >
          <div class="dropdown-header px-3 py-2">
            <small class="text-muted">{{ Lang.get("messages.profile") }}</small>
          </div>

          <a
            class="dropdown-item d-flex align-items-center justify-content-between"
            href="#"
            v-if="isSystemAdmin"
            @click.prevent="$router.push('/super-admin/general-settings')"
          >
            <span>{{ Lang.get("messages.general_settings") }}</span>
            <i class="fas fa-cogs text-muted" style="font-size: 0.8rem"></i>
          </a>

          <a
            class="dropdown-item d-flex align-items-center justify-content-between"
            href="#"
            v-if="isTeacher"
            @click.prevent="openProfileModal()"
          >
            <span>{{ Lang.get("messages.profile") }}</span>
            <i
              class="fas fa-user-circle text-muted"
              style="font-size: 0.8rem"
            ></i>
          </a>

          <div class="dropdown-divider mx-2 my-1"></div>

          <a
            class="dropdown-item d-flex align-items-center justify-content-between"
            href="#"
            @click.prevent="logout"
          >
            <span class="text-danger">{{ Lang.get("messages.logout") }}</span>
            <i
              class="fas fa-sign-out-alt text-danger"
              style="font-size: 0.8rem"
            ></i>
          </a>
        </div>
      </div>
    </div>
    <modal target="p-profile-modal" ref="profileModal">
      <template #body>
        <profileModal :request="user" @updated="onUpdate" />
      </template>
    </modal>
  </header>
</template>

<script>
import eBus from "@/event-bus";
import StorageService from "@services/storage.service";
import ApiService from "@services/api.service";
import Favorite from "@api/favorite.api";
import profileModal from "@components/modals/profileModal";
import Classes from "@api/class.api";
import Messenger from "@api/messenger.api";
import NotificationMongo from "@api/notification-mongo.api";
import School from "@api/school.api";
import Language from "@api/language.api";
import axios from "axios";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("users", ["user"]),
    ...mapGetters(["isSuperadminLoggedSchool", "isDistrictLoggedSchool"]),
    isTeacher() {
      return this.hasRole(this.ROLES.TEACHERS);
    },
    teacherClassesIDs() {
      return this.teacherClasses.map(({ id }) => id);
    },
    notificationChannelName() {
      return `notification.user.${this.user.id}`;
    },
    isHod() {
      return this.hasRole(this.ROLES.HOD);
    },
    isSuperadmin() {
      return this.user.isSuperadmin;
    },
    isSystemAdmin() {
      return this.hasRole(this.ROLES.SYSTEMADMINS);
    },

    activeLanguages() {
      return this.availableLanguages.filter((l) => l.is_active);
    },

    currentLanguageNativeName() {
      const current = this.availableLanguages.find(
        (l) => l.code === this.currentLocale,
      );
      return current
        ? current.native_name
        : this.currentLocale.startsWith("ar")
        ? "العربية"
        : "English";
    },
  },
  components: {
    profileModal,
  },
  data() {
    return {
      notifications: [],
      teacherClasses: [],
      mongoNotifications: [],
      mongoNotificationsCount: 0,
      isHodLoggedAsTeacher: false,
      schools: [],
      showSchoolSelector: false,
      availableLanguages: [],
      currentLocale: "ar_kw",
    };
  },
  props: {
    fav_list: {
      type: Array,
      required: false,
    },
  },

  mounted() {
    this.$nextTick(() => {
      $('[data-toggle="dropdown"]').dropdown();
    });

    document.addEventListener("click", this.handleClickOutside);

    eBus.$on("AccessTeacher", (access) => {
      this.isHodLoggedAsTeacher = access;
    });

    // Initialize FCM for web push notifications
    this.initializeFCM();
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
    // Set locale according to school if exists
    if (this.user.school) {
      let lang = StorageService.getItem("locale");

      if (!lang) {
        let langID = this.user.school.lang.id;
        if (langID == 1) {
          lang = "ar";
        } else {
          lang = "en";
        }
      }

      this.setLocale(lang);

      // Set school header if superadmin logged school
      if (this.isSuperadminLoggedSchool || this.isDistrictLoggedSchool) {
        ApiService.setHeader("SMS-School", this.user.school.id);
      }
    } else {
      let lang = StorageService.getItem("locale");
      if (lang) {
        this.setLocale(lang);
        ApiService.setHeader("SMS-Locale", lang);
      }
    }
    if (this.isTeacher) {
      this.initMessenger();
      this.getTeacherClasses();
      this.getUnreadNotifications();
    }

    // Load MongoDB notifications for all users
    this.getMongoNotifications();
    this.getMongoNotificationsCount();
    eBus.$on("update-favourites", this.handleChangeFavourites);

    // Initialize language switcher
    this.currentLocale = this.Lang.getLocale();
    this.fetchLanguages();
  },

  methods: {
    ...mapMutations("users", ["auth_success"]),
    ...mapMutations(["setSuperadminLoggedSchool", "setDistrictLoggedSchool"]),

    logout() {
      document.cookie = "access_token=; path=/; max-age=-1; SameSite=Lax";
      this.$store.dispatch("users/logout");
    },

    openProfile() {},

    handleClickOutside(event) {
      if (
        this.showSchoolSelector &&
        !event.target.closest(".dropdown-menu") &&
        !event.target.closest(".reset-view-btn")
      ) {
        this.showSchoolSelector = false;
      }
    },

    changeLocale(lang) {
      this.saveLocale(lang);
      this.setLocale(lang);
      // this.$router.go(0); // Removing page reload to provide a smoother experience
    },
    setLocale(lang) {
      this.saveLocale(lang);
      this.changeDir(lang);
    },
    saveLocale(lang) {
      this.Lang.setLocale(lang);
      ApiService.setHeader("SMS-Locale", lang);
      StorageService.saveItem("locale", lang);
    },
    changeDir(lang) {
      this.Lang.setLocale(lang);
      let htmlEl = document.getElementsByTagName("html")[0];
      if (lang === "en") {
        htmlEl.dir = "ltr";
      } else if (lang.startsWith("ar")) {
        // Force RTL for any Arabic dialect (including ar_kw)
        htmlEl.dir = "rtl";
      }
      let cssLink = document.head.querySelector("link[data-app='vuejs']");
      let path = cssLink.href;
      let filename = path.substring(path.lastIndexOf("/") + 1);
      const targetLang = lang.startsWith("ar") ? "ar" : "en";
      cssLink.href = cssLink.href.replace(filename, `app-${targetLang}.css`);
    },

    backToSuperadminPanel() {
      // Update user in local storage
      let user = StorageService.getItem("user", true, true);
      delete user.school;
      StorageService.saveItem("user", user, true);

      // Update roles in local storage
      let roles = StorageService.getItem("roles", true, true);
      _.remove(roles, (role) => {
        return role == this.ROLES.SCHOOLADMINS;
      });
      StorageService.saveItem("roles", roles, true);

      // Update user & roles in store
      this.auth_success();
      StorageService.removeItem("superadminLoggedSchool");
      this.setSuperadminLoggedSchool();

      ApiService.removeHeader("SMS-School");

      eBus.$emit("superAdminAsSchoolAdmin");

      if (this.$route.path !== "/super-admin/dashboard") {
        this.$router.push("/super-admin/dashboard");
      }
    },

    backToHodDashboard() {
      // Remove teacher from storage to return to HOD mode
      StorageService.removeItem("teacher");

      // Emit event to update sidebar and other components
      eBus.$emit("hodBackToMain");
      this.isHodLoggedAsTeacher = false;

      // Navigate to HOD dashboard
      if (this.$route.path !== "/hod-dashboard") {
        this.$router.push("/hod-dashboard");
      }
    },
    getUserFavourites() {
      this.$emit("getUserFavourites");
    },
    handleChangeFavourites() {
      this.getUserFavourites();
    },
    removeFromFav(item) {
      Favorite.delete(item).then(() => {
        this.getUserFavourites();
      });
    },
    openProfileModal() {
      this.selectedTrip = _.cloneDeep(this.user);
      this.$refs.profileModal.open(this.Lang.get("messages.profile"));
      setTimeout(() => {
        document.body.classList.remove("modal-open");
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
        document.body.style.overflow = "auto";
      }, 300);
    },
    onUpdate(data) {
      this.$refs.profileModal.close();
      this.$snotify.success(data.message);
    },
    initMessenger() {
      if (typeof Echo === "undefined") {
        console.warn(
          "⚠️ Laravel Echo is not defined. Real-time notifications are disabled.",
        );
        return;
      }
      if (!this.subscriptions) {
        this.subscriptions = {};
      }

      // Only subscribe once
      if (!this.subscriptions[this.notificationChannelName]) {
        let channel = Echo.private(this.notificationChannelName);

        channel.listen(".new.chat", (res) => {
          let chatData = res.data;

          if (!_.has(this.subscriptions, chatData.channel.name)) {
            let subChannel = Echo.private(chatData.channel.name);

            subChannel.listen(".new.message", this.newMessageListener);

            this.$set(this.subscriptions, chatData.channel.name, subChannel);
          }
        });

        // mark subscription as active
        this.subscriptions[this.notificationChannelName] = channel;
      }
    },

    newMessageListener(res) {
      let messageData = res.data;
      Messenger.getNotificationSender(messageData.from_user, {
        scope: "user.micro,parent.micro",
      }).then((res) => {
        let sender = res.data.data;
        new Audio("/sounds/pristine-609.mp3").play();

        let content = `<strong>${sender.parent.name}</strong>`;

        if (messageData.message && messageData.message.trim() !== "") {
          content += ` <p>${messageData.message}</p>`;
        }

        this.$snotify.html(content);
        this.getUnreadNotifications();
        if (
          this.notifications.some((n) => n.sender.id == messageData.from_user)
        ) {
          return false;
        }

        this.notifications.push({
          sender: sender,
        });
      });
    },
    getTeacherClasses() {
      Classes.list({
        page: 0,
        teacher: this.user.teacher.id,
      }).then((res) => (this.teacherClasses = res.data.data));
    },

    getUnreadNotifications() {
      Messenger.getUnreadNotifications({
        scope: "user.micro,parent.micro",
      }).then((res) => {
        this.notifications = res.data.data;
      });
    },

    getParentClass(classes) {
      if (!classes) return null;
      return classes.find((c) =>
        this.teacherClassesIDs.includes(_.get(c, "id")),
      );
    },

    // MongoDB Notifications methods
    getMongoNotifications() {
      NotificationMongo.getRecent({ limit: 25 })
        .then((res) => {
          if (res.data.success) {
            this.mongoNotifications = res.data.data;
          }
        })
        .catch((error) => {
          console.error("Error fetching mongo notifications:", error);
        });
    },

    getMongoNotificationsCount() {
      NotificationMongo.getUnreadCount()
        .then((res) => {
          if (res.data.success) {
            this.mongoNotificationsCount = res.data.data.unread_count;
          }
        })
        .catch((error) => {
          console.error("Error fetching mongo notifications count:", error);
        });
    },

    markNotificationAsRead(notificationId, link) {
      // Mark as read first
      NotificationMongo.markAsRead(notificationId)
        .then((res) => {
          if (res.data.success) {
            // Update local data
            this.getMongoNotificationsCount();
            this.getMongoNotifications();

            // Navigate to link if provided
            if (link) {
              this.$router.push(`/${link}`);
            }
          }
        })
        .catch((error) => {
          console.error("Error marking notification as read:", error);
        });
    },
    resetDashboard() {
      eBus.$emit("refresh-admin-dashboard");
    },

    // School Selection Methods
    fetchSchools() {
      School.list()
        .then((response) => {
          this.schools = response.data.data || response.data;
        })
        .catch((error) => {
          console.error("Error fetching schools", error);
        });
    },

    toggleSchoolSelector() {
      this.showSchoolSelector = !this.showSchoolSelector;
      if (this.showSchoolSelector && this.schools.length === 0) {
        this.fetchSchools();
      }
    },

    selectSchool(school) {
      // Logic to login as school admin
      // This mirrors the logic in backToSuperadminPanel but in reverse (setting school)
      // AND validation logic found in SuperAdmin dashboards usually

      // 1. Set User School in Storage
      let user = StorageService.getItem("user", true, true);
      user.school = school;
      StorageService.saveItem("user", user, true);

      // 2. Set Roles (add SCHOOLADMINS)
      let roles = StorageService.getItem("roles", true, true);
      if (!roles.includes(this.ROLES.SCHOOLADMINS)) {
        roles.push(this.ROLES.SCHOOLADMINS);
        StorageService.saveItem("roles", roles, true);
      }

      // 3. Update Store
      this.auth_success();
      StorageService.saveItem("superadminLoggedSchool", true, true);
      this.setSuperadminLoggedSchool();
      ApiService.setHeader("SMS-School", school.id);

      eBus.$emit("superAdminAsSchoolAdmin");

      // 4. Navigate to dashboard
      this.showSchoolSelector = false;
      if (this.$route.path !== "/") {
        this.$router.push("/");
      } else {
        window.location.reload();
      }
    },

    // Initialize Firebase Cloud Messaging for web push notifications
    async initializeFCM() {
      try {
        // Check if browser supports notifications
        if (!("Notification" in window)) {
          console.warn("⚠️ Browser does not support notifications");
          return;
        }

        // Check if service worker is supported
        if (!("serviceWorker" in navigator)) {
          console.warn("⚠️ Service worker not supported");
          return;
        }

        // Check current permission status

        // Check if FCM token already exists in localStorage
        const storedToken = localStorage.getItem(`fcm_token_${this.user.id}`);
        const tokenTimestamp = localStorage.getItem(
          `fcm_token_timestamp_${this.user.id}`,
        );
        const now = Date.now();
        const thirtyDays = 30 * 24 * 60 * 60 * 1000;

        // Initialize Firebase (Reading from .env via window object)
        const firebaseConfig = window.firebaseConfig;

        if (
          !firebaseConfig ||
          !firebaseConfig.apiKey ||
          !firebaseConfig.projectId ||
          !firebaseConfig.appId
        ) {
          console.warn(
            "⚠️ Firebase configuration is incomplete. FCM will be disabled.",
          );
          console.warn(
            "Check your .env for: FIREBASE_API_KEY, FIREBASE_PROJECT_ID, FIREBASE_APP_ID",
          );
          return;
        }

        // Check if Firebase is already initialized
        if (!window.firebaseApp) {
          window.firebaseApp = firebase.initializeApp(firebaseConfig);
        }

        const messaging = firebase.messaging();

        // Setup message listener for foreground notifications (like Blade)
        messaging.onMessage((payload) => {
          // Play notification sound
          new Audio("/sounds/pristine-609.mp3").play().catch(() => {});

          // Show toastr notification (same as Blade)
          const title = payload.notification?.title || "إشعار جديد";
          const body = payload.notification?.body || "";

          // Get route based on notification type
          const route = this.getNotificationRoute(payload.data);

          // Use toastr (make sure toastr is loaded)
          if (typeof toastr !== "undefined") {
            toastr.options = {
              closeButton: true,
              progressBar: false,
              timeOut: 0, // يبقى إلى الأبد حتى يغلقه المستخدم
              extendedTimeOut: 0,
              onclick: () => {
                this.$router.push(route);
              },
            };
            toastr.info(`<strong>${title}</strong><p>${body}</p>`);
          } else {
            console.warn("⚠️ toastr is not loaded, falling back to console");
          }

          // Update notification counter and list
          this.getMongoNotifications();
          this.getMongoNotificationsCount();
        });

        // If token exists and is fresh (< 30 days), skip registration
        if (
          storedToken &&
          tokenTimestamp &&
          now - tokenTimestamp < thirtyDays
        ) {
          this.setupServiceWorkerListener();
          return;
        }

        // Request permission only if needed (like Blade)
        if (Notification.permission === "granted") {
          await this.completeFCMRegistration(messaging);
        } else if (Notification.permission === "default") {
          // Ask for permission only once (like Blade)
          const permission = await Notification.requestPermission();

          if (permission === "granted") {
            await this.completeFCMRegistration(messaging);
          } else {
            console.warn("⚠️ Notification permission denied");
          }
        } else {
          console.warn("🚫 Notification permission is blocked");
        }
      } catch (error) {
        console.error("❌ FCM initialization error:", error);
      }
    },

    // Complete FCM registration process
    async completeFCMRegistration(messaging) {
      try {
        // Register service worker
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js",
          {
            scope: "/",
          },
        );

        // Wait for Service Worker to be ready
        await navigator.serviceWorker.ready;

        // Setup listener for messages from Service Worker
        this.setupServiceWorkerListener();

        // Get FCM token with VAPID key from .env
        const vapidKey = window.firebaseVapidKey;

        if (!vapidKey) {
          console.error(
            "❌ VAPID Key is missing! Add FIREBASE_VAPID_KEY to your .env file.",
          );
          throw new Error("VAPID Key is required for FCM");
        }

        const token = await messaging.getToken({
          vapidKey: vapidKey,
          serviceWorkerRegistration: registration,
        });

        if (token) {
          const storedToken = localStorage.getItem(`fcm_token_${this.user.id}`);

          if (token !== storedToken) {
            // Save token to localStorage
            localStorage.setItem(`fcm_token_${this.user.id}`, token);
            localStorage.setItem(
              `fcm_token_timestamp_${this.user.id}`,
              Date.now(),
            );

            // Register token with backend
            await this.registerFCMToken(token);
          } else {
          }
        } else {
          console.warn("⚠️ No FCM token received");
        }
      } catch (error) {
        console.error("❌ FCM registration error:", error);

        if (error.code === "messaging/permission-blocked") {
          console.error(
            "🚫 Notification permission is blocked. Please enable it in browser settings.",
          );
        } else if (error.code === "messaging/notifications-blocked") {
          console.error("🚫 Notifications are blocked by the browser.");
        }
      }
    },

    // Setup listener for messages from Service Worker
    setupServiceWorkerListener() {
      if (!navigator.serviceWorker) return;

      navigator.serviceWorker.addEventListener("message", (event) => {
        // When notification is clicked
        if (event.data && event.data.type === "NOTIFICATION_CLICKED") {
          // Update counter and list
          this.getMongoNotificationsCount();
          this.getMongoNotifications();

          // Play sound
          new Audio("/sounds/pristine-609.mp3").play().catch(() => {});

          // Navigate to URL
          if (event.data.url) {
            this.$router.push(event.data.url);
          }
        }

        // When background notification is received
        if (
          event.data &&
          event.data.type === "BACKGROUND_NOTIFICATION_RECEIVED"
        ) {
          // Play sound always
          new Audio("/sounds/pristine-609.mp3").play().catch((e) => {});

          // Show toastr notification if page is visible (same as Blade)
          if (
            !document.hidden &&
            event.data.payload &&
            typeof toastr !== "undefined"
          ) {
            const title =
              event.data.payload?.notification?.title || "إشعار جديد";
            const body = event.data.payload?.notification?.body || "";

            toastr.options = {
              closeButton: true,
              progressBar: false,
              timeOut: 0,
              extendedTimeOut: 0,
              onclick: () => {
                window.location.href = "/notifications";
              },
            };
            toastr.info(`<strong>${title}</strong><p>${body}</p>`);
          }

          // Update counter and list
          this.getMongoNotificationsCount();
          this.getMongoNotifications();
        }
      });

      // Update notifications when page becomes visible
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
          this.getMongoNotificationsCount();
          this.getMongoNotifications();
        }
      });
    },

    // Get notification route based on type
    getNotificationRoute(data) {
      let route = "/show-notifications";

      try {
        if (data && data.open_with) {
          const openWith =
            typeof data.open_with === "string"
              ? JSON.parse(data.open_with)
              : data.open_with;

          const type = openWith.type;

          const routeMap = {
            FromMerit: "/merits",
            FromIncident: "/descipliens",
            FromGrade: "/grade-books",
            FromNewGrade: "/grade-books",
            FromHomeWork: "/homework",
            FromHomeworkEvaluation: "/homework",
            FromExtraResource: "/extra_resource",
            FromAssessment: "/assessments",
            FromLessonPlan: "/lesson_plans",
            FromAttendance: "/attendance",
            FromWeeklyPlan: "/weekly_plan",
            FromSchoolAds: "/announcements",
            FromGroupMeeting: "/parent-meetings",
            FromIndividualMeeting: "/parent/individual-meetings",
            FromSchoolTrip: "/trips",
            FromInvoicePayment: "/all-payments",
            FromAdmissionInvoicePayment: "/admission",
            FromFees: "/all-payments",
            FromSystem: "/show-notifications",
          };

          if (type && routeMap[type]) {
            route = routeMap[type];
          }
        }
      } catch (error) {
        console.error("❌ Error parsing notification type:", error);
      }

      return route;
    },

    // Register FCM token with backend
    async registerFCMToken(token) {
      try {
        const response = await ApiService.post("/fcm-token/register", {
          fcm_token: token,
          device_type: "web",
        });

        if (response.data.success) {
        }
      } catch (error) {
        console.error("❌ Error registering FCM token:", error);
      }
    },

    // Language Switcher Methods
    async fetchLanguages() {
      try {
        const response = await Language.active();
        this.availableLanguages = response.data.data;
      } catch (error) {
        console.error("Error fetching languages:", error);
        // Fallback static list if API fails
        this.availableLanguages = [
          {
            code: "ar_kw",
            native_name: "العربية (الكويت)",
            is_active: true,
            direction: "rtl",
          },
          {
            code: "en",
            native_name: "English",
            is_active: true,
            direction: "ltr",
          },
        ];
      }
    },

    async handleLanguageChange(newLocale) {
      console.log("Language changed to:", newLocale);
      if (this.currentLocale === newLocale) return;

      try {
        const isRTL = newLocale.startsWith("ar");
        const direction = isRTL ? "rtl" : "ltr";

        // 1. Update Lang and Service Headers
        this.Lang.setLocale(newLocale);
        this.currentLocale = newLocale;
        localStorage.setItem("locale", newLocale);
        ApiService.setHeader("SMS-Locale", newLocale);
        StorageService.saveItem("locale", newLocale);

        // 2. Update Backend Session (Silent)
        axios
          .post(
            "/change-language",
            { locale: newLocale },
            {
              headers: {
                "X-CSRF-TOKEN": document
                  .querySelector('meta[name="csrf-token"]')
                  .getAttribute("content"),
                "Content-Type": "application/json",
              },
            },
          )
          .then(() => {
            location.reload();
          })
          .catch((err) => console.error("Backend language sync failed:", err));

        // 3. Update DOM Attributes
        document.documentElement.setAttribute("lang", newLocale);
        document.documentElement.setAttribute("dir", direction);

        // 4. Dynamic Style Swapping (No Reload)
        const bootstrapLink = document.getElementById("bootstrap-link");
        const mainStyleLink = document.getElementById("main-style-link");
        let customEnLink = document.getElementById("custom-en-link");

        if (bootstrapLink) {
          bootstrapLink.href = isRTL
            ? "https://cdn.rtlcss.com/bootstrap/v4.1.3/css/bootstrap.min.css"
            : "https://cdn.jsdelivr.net/npm/bootstrap@4.1.3/dist/css/bootstrap.min.css";
        }

        if (mainStyleLink) {
          mainStyleLink.href = isRTL
            ? "/assets/css/style-ar.css"
            : "/assets/css/style-en.css";
        }

        const appCssLink = document.head.querySelector(
          "link[data-app='vuejs']",
        );
        if (appCssLink) {
          const currentHref = appCssLink.href;
          const targetSuffix = isRTL ? "app-ar.css" : "app-en.css";
          if (!currentHref.includes(targetSuffix)) {
            appCssLink.href = isRTL
              ? currentHref.replace("app-en", "app-ar")
              : currentHref.replace("app-ar", "app-en");
          }
        }

        if (!isRTL) {
          if (!customEnLink) {
            customEnLink = document.createElement("link");
            customEnLink.rel = "stylesheet";
            customEnLink.id = "custom-en-link";
            customEnLink.href = "/assets/front_end/css/new_style/custom_en.css";
            document.head.appendChild(customEnLink);
          }
        } else if (customEnLink) {
          customEnLink.remove();
        }

        // 5. Global Event to trigger re-renders in components
        eBus.$emit("locale-changed", newLocale);
      } catch (error) {
        console.error("Language switch failed:", error);
      }
    },
  },
};
</script>

<style scoped>
.page-title {
  color: #1a1a1a;
}

.notifications-button {
  position: relative;
}

.dropdown-menu.notification {
  min-width: 300px;
  max-width: 400px;
}

.dropdown-menu.notification .custom-ul {
  max-height: 300px;
  overflow-y: auto;
}

.notification_img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.custom-anc {
  text-decoration: none;
  padding: 8px 16px;
  display: block;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.custom-anc:hover {
  background-color: #f8f9fa;
  text-decoration: none;
}

.fw-bold {
  font-weight: bold !important;
}

/* Style for unread notifications */
.custom-ul li {
  cursor: pointer;
  transition: background-color 0.2s;
}

.custom-ul li:hover {
  background-color: #f8f9fa;
}

/* Modern Language Switcher Styles - System Colors */
.lang-switcher-navbar,
.school-switcher-navbar,
.user-profile-navbar {
  margin: 0 8px;
}

.modern-lang-btn-navbar {
  background: #ffffff !important;
  color: #1a1a1a !important;
  border: 1px solid #e0e0e0 !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-height: 38px;
}

.modern-lang-btn-navbar:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  border-color: #28b6be !important;
  background: #f8f9fa !important;
}

.modern-lang-btn-navbar::after {
  border-top-color: #1a1a1a !important;
  margin-left: 8px;
  margin-right: 8px;
  /* For RTL support */
}

.modern-lang-btn-navbar .lang-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #e9f7f8;
  border-radius: 50%;
  color: #28b6be;
}

.modern-lang-btn-navbar .lang-icon-wrapper i {
  font-size: 0.85rem;
}

.modern-lang-btn-navbar .lang-text {
  margin-left: 8px;
  margin-right: 8px;
  color: #1a1a1a;
  display: inline-block;
  /* Ensure proper flow */
}

.modern-lang-dropdown {
  border-radius: 12px !important;
  border: 1px solid #e9ecef !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12) !important;
  padding: 8px 0 !important;
  margin-top: 8px !important;
  min-width: 200px !important;
  animation: slideDown 0.2s ease-out;
  background: #ffffff;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modern-lang-dropdown .dropdown-header {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.5px;
  color: #6c757d;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 4px;
}

.modern-lang-dropdown .dropdown-item {
  padding: 10px 20px !important;
  font-weight: 500;
  transition: all 0.2s;
  border-radius: 6px;
  margin: 2px 8px;
  color: #1a1a1a !important;
  /* Force readability */
}

.modern-lang-dropdown .dropdown-item:hover {
  background: #f8f9fa !important;
  color: #28b6be !important;
}

.modern-lang-dropdown .dropdown-item.active {
  background: #28b6be !important;
  color: #ffffff !important;
  /* Ensure white text on blue background */
}

.modern-lang-dropdown .dropdown-item.active:hover {
  background: #2199a0 !important;
  color: #ffffff !important;
}

.modern-lang-dropdown .dropdown-item i.fa-check {
  font-size: 0.8rem;
  color: #28a745 !important;
  /* Green checkmark normally */
}

.modern-lang-dropdown .dropdown-item.active i.fa-check {
  color: #ffffff !important;
  /* White checkmark when active */
}

/* Responsive: hide text on small screens */
@media (max-width: 768px) {
  .modern-lang-btn-navbar .lang-text {
    display: none;
  }

  .modern-lang-btn-navbar {
    padding: 8px 12px !important;
  }
}
</style>
